<div style="text-align: center">
    <div tabindex="0" class="fa fa-lg fa-calendar" style="font-size: 120px; margin-top: 50px; color: orangered"></div>
    <h1>{{'HOME.BANNER'| translate}}</h1>
    <p>{{'HOME.SHORT_DESCRIPTION' | translate}}</p>
</div>